import React from 'react';
import { ProjectAccessProvider as BaseProjectAccessProvider } from 'context/projectAccess/ProjectAccessContext';
import { Project } from '../../../../server/graphql/__generated.types';

interface ProjectAccessProviderWrapperProps {
  project: Project;
  children: React.ReactNode;
}

const ProjectAccessProvider = (props: ProjectAccessProviderWrapperProps) => {
  const { project, children } = props;
  const ability = project?.projectAccess?.viewerAccessRole
    ?.permissions as string;

  return (
    <BaseProjectAccessProvider ability={ability}>
      {children}
    </BaseProjectAccessProvider>
  );
};

export default ProjectAccessProvider;
